import qs from 'qs';
import axios from '@/modules/axios';
import store from '@/store';

function loadVideos(filter) {
  const { projectId } = store.getters.currentProject;
  if (filter) {
    const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
    return axios.get(`/projects/${projectId}/videos${query}`);
  }
  return axios.get(`/projects/${projectId}/videos`);
}

function loadVideoDetail(videoId, filter) {
  const { projectId } = store.getters.currentProject;
  if (filter) {
    const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
    return axios.get(`/projects/${projectId}/videos/${videoId}/${query}`);
  }
  return axios.get(`/projects/${projectId}/videos/${videoId}`);
}

function loadRetentionGraph(videoId, filter) {
  const { projectId } = store.getters.currentProject;
  if (filter) {
    const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
    return axios.get(`/projects/${projectId}/videos/${videoId}/retention/${query}`);
  }
  return axios.get(`/projects/${projectId}/videos/${videoId}`);
}

function loadVideoStats(videoId, filter) {
  const { projectId } = store.getters.currentProject;
  if (filter) {
    const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
    return axios.get(`/projects/${projectId}/videos/${videoId}/stats/${query}`);
  }
  return axios.get(`/projects/${projectId}/videos/${videoId}`);
}


export {
  loadVideos,
  loadVideoDetail,
  loadRetentionGraph,
  loadVideoStats,
};
